import {
  type CommandProperties,
  createCommand,
} from '@atlassian/rovo-content-bridge-api';

/**
 * @see {@link SaveDraftChangesCommand}
 */
export type SaveDraftChangesCommandProperties = CommandProperties;

/**
 * Command to save draft changes in the database native embed experience.
 *
 * This command persists any pending changes made to database content,
 * ensuring data consistency and allowing users to save their work
 * without leaving the embed context.
 */
export const SaveDraftChangesCommand = createCommand<
  SaveDraftChangesCommandProperties,
  void
>('save-draft-changes-command');
